<benefits-banner
  class="hoverable"
  [infoText]="infoText"
  [currencyText]="ordersEuroText"
  (navigate)="onClick()"
></benefits-banner>
